"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameConstant = void 0;
exports.GameConstant = {
    startingCardsCount: 7,
    maxRoomPlayers: 8,
    maxPublicRoomPlayers: 4,
    maxPrivateRoomPlayers: 8,
    minRoomPlayers: 2,
    maxMissedRounds: 2,
    maxRoundDuration: 8,
    baseGameDuration: 180,
    additionalTimePerPlayer: 30,
    cancelGameAfterInactivitySeconds: 30,
    endGameDelaySeconds: 0.5,
    maxLoss: 150,
    maxGain: 300,
    minLossPerRank: 20,
    leaderboardDailyCap: 10,
    emoteCooldownSeconds: 3,
    chatCooldownSeconds: 2,
};
